const Data = [
    {
        name: "Annual Wonderland ",
        address: "83 Victoria Street, London, SW1H 0HW.",
        ph: "(257) 563-7401",
        date: "September 14, 2022",
        image: "https://img.freepik.com/free-vector/music-party-festival-dj-poster-template_23-2148575888.jpg?size=338&ext=jpg&uid=R36971962&ga=GA1.2.1749564066.1614758758"
    },
    {
        name: "Boogie Horizon  ",
        address: "40 Bowling Green, London, EC1R 0NE",
        ph: "(372) 587-2335",
        date: "April 19, 2022",
        image: "https://img.freepik.com/free-vector/music-festival-poster-template_23-2148592604.jpg?size=338&ext=jpg&uid=R36971962&ga=GA1.2.1749564066.1614758758"
    },
    {
        name: "Boogie Paradise  ",
        address: "Cecilia Chapman 711-2880 Nulla St.Mankato Mississippi 96522",
        ph: "(786) 713-8616",
        date: "November 18, 2023",
        image: "https://img.freepik.com/free-vector/dj-woman-music-event-poster-template_52683-41468.jpg?size=338&ext=jpg&uid=R36971962&ga=GA1.2.1749564066.1614758758"
    },

    {
        name: "Dance Paradise  ",
        address: "Iris Watson P.O. Box 283 8562 Fusce Rd. Frederick Nebraska 20620",
        ph: "(793) 151-6230",
        date: "December 09, 2022",
        image: "https://img.freepik.com/free-vector/music-event-poster-template_52683-41484.jpg?size=338&ext=jpg&uid=R36971962&ga=GA1.2.1749564066.1614758758"
    },

    {
        name: "Festival Oasis  ",
        address: "Celeste Slater 606-3727 Ullamcorper. Street Roseville NH 11523",
        ph: "(492) 709-6392",
        date: "March 21, 2023",
        image: "https://img.freepik.com/free-vector/music-event-poster-template-with-image_52683-41486.jpg?size=338&ext=jpg&uid=R36971962&ga=GA1.2.1749564066.1614758758"
    },

    {
        name: "Fest Invasion ",
        address: "Theodore Lowe Ap #867-859 Sit Rd. Azusa New York 39531",
        ph: "(654) 393-5734",
        date: "April 30, 2022",
        image: "https://img.freepik.com/free-vector/music-event-poster-with-photo_52683-42061.jpg?size=338&ext=jpg&uid=R36971962&ga=GA1.2.1749564066.1614758758"
    },

    {
        name: "Fest Kingdom ",
        address: "Calista Wise 7292 Dictum Av. San Antonio MI 47096",
        ph: "(404) 960-3807",
        date: "September 09, 2022",
        image: "https://img.freepik.com/free-vector/2021-music-event-poster_23-2148625146.jpg?size=338&ext=jpg&uid=R36971962&ga=GA1.2.1749564066.1614758758"
    },

    {
        name: "Gala Jungle  ",
        address: "Kyla Olsen Ap #651-8679 Sodales Av. Tamuning PA 10855",
        ph: "(314) 244-6306",
        date: "June 20, 2022",
        image: "https://img.freepik.com/free-vector/2021-music-event-poster_52683-40231.jpg?size=338&ext=jpg&uid=R36971962&ga=GA1.2.1749564066.1614758758"
    },

    {
        name: "Gig Glory  ",
        address: "Forrest Ray 191-103 Integer Rd. Corona New Mexico 08219",
        ph: "(947) 278-5929",
        date: "September 21, 2023",
        image: "https://img.freepik.com/free-vector/2021-music-festival-poster-template_23-2148580245.jpg?size=338&ext=jpg&uid=R36971962&ga=GA1.2.1749564066.1614758758"
    },

    {
        name: "Midsummer Splendour  ",
        address: "Hiroko Potter P.O. Box 887 2508 Dolor. Av. Muskegon KY 12482",
        ph: "(684) 579-1879",
        date: "July 10, 2022",
        image: "https://img.freepik.com/free-vector/man-with-headphones-music-event-poster-template_52683-41463.jpg?size=338&ext=jpg&uid=R36971962&ga=GA1.2.1749564066.1614758758"
    },
]
export default Data;